<div class="flex flex-col items-center">
  <div *ngIf="title()" class="text-lg font-semibold mb-2" [ngClass]="progressColor">
    {{ title() }}
  </div>

  <div [class]="circleClass" (click)="emitClick()">
    <svg class="w-full h-full transform -rotate-90" viewBox="0 0 120 120">
      <circle cx="60" cy="60" r="50" fill="transparent" stroke="currentColor" stroke-width="10" class="text-gray-300"/>
    </svg>

    <svg class="absolute top-0 left-0 w-full h-full transform -rotate-90" viewBox="0 0 120 120">
      <circle cx="60" cy="60" r="50" fill="transparent" stroke="currentColor" stroke-width="10"
        stroke-dasharray="314" [attr.stroke-dashoffset]="314 - progressStrokeDash" [ngClass]="progressColor"
        style="transition: stroke-dashoffset 0.3s ease-in-out"/>
    </svg>

    <div class="absolute inset-0 flex flex-col items-center justify-center">
      <span [ngClass]="[textSize, 'font-bold', progressColor]">{{ animatedPercentage | number: '1.0-0' }}%</span>
      <ui-icon *ngIf="icon" [icon]="icon() || EIcon.Bell" [size]="size()" [color]="color()" [fill]="true" class="mt-1"></ui-icon>
    </div>
  </div>
</div>
